import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 33"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 16.096a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2zM21 21.096a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 3.096h12c.27 0 .516.108.696.282l.011.01 7 7 .007.007a1 1 0 0 1 .28.584v.002a1 1 0 0 1 .006.115v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-22a2 2 0 0 1 2-2m16.585 7L20 6.511v3.585zm-5.585-5v6a1 1 0 0 0 1 1h6v15H7v-22z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileDocument = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileDocument);
export default Memo;
